import React, { Component } from 'react'

export class AsResponsiveContent extends Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  componentDidMount() {
    this.ref.current.addEventListener('ready', this._onReady.bind(this));  
  }

  _onReady(event) {
    const { onReady } = this.props;
    onReady && onReady(event);
  }

  render() {
    return (
      <as-responsive-content ref={this.ref}>
        {this.props.children}
      </as-responsive-content>
    )
  }
}

export default AsResponsiveContent
